import React from "react";

const PageTitle404 = () => {
    return (
        <section id="page-title" className="block">
            <div className="wrapper h-100">
                  <div className="d-flex justify-content-between position-relative h-100">
                      <div className="align-self-center">
                          <div className="title">
                              <h1 className="text-secondary">404</h1>
                          </div>
                      </div>
                  </div>
              </div>
        </section>
    );
};

export default PageTitle404;
